import { render } from "./AddChankangMealDialog.vue?vue&type=template&id=3ecaac20&scoped=true&ts=true"
import script from "./AddChankangMealDialog.vue?vue&type=script&lang=ts"
export * from "./AddChankangMealDialog.vue?vue&type=script&lang=ts"

import "./AddChankangMealDialog.vue?vue&type=style&index=0&id=3ecaac20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecaac20"]])

export default __exports__